import React from "react";
import { isNull } from "lodash";
import Modal from "react-modal";

interface GraphInfoPopupProps {
  //   closePopup: () => void;
  closePopup: () => void;
  selectedGraphCode: string | null;
}

export const GraphInfoPopup: React.FC<GraphInfoPopupProps> = ({
  closePopup,
  selectedGraphCode,
}) => {
  //const SelectedGraphComponent = selectedBuildingId
  //? graphComponents[selectedBuildingId]
  //: null;

  const handleCloseModal = () => {
    closePopup();
  };

  return (
    <Modal
      isOpen={!isNull(selectedGraphCode)}
      // isOpen={isOpen}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.25)",
        },
        content: {
          position: "absolute",
          top: "100px",
          left: "175px",
          right: "175px",
          bottom: "100px",
          border: "1px solid #ccc",
          borderRadius: "25px",
          padding: 60,
        },
      }}
    >
      <div
        style={{
          // marginTop: "15px",
          // marginRight: "15px",
          float: "right",
          display: "flex",
          borderRadius: "10px",
          border: "2px solid #E5E5E5",
          // width: 291,
          // height: 75,
          flexShrink: 0,
          padding: 5,
        }}
      >
        <p>Hi {selectedGraphCode}</p>
        <button onClick={handleCloseModal}>close</button>
      </div>
    </Modal>
  );
};
